"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _input = _interopRequireDefault(require("../../../../../core/input"));
var _alert = _interopRequireDefault(require("../../../../../core/alert"));
var _offerHistory = _interopRequireDefault(require("./offer-history"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This displays the appropriate button to allow the user to accept online/disallow payment.
// for a waiting list entry.
var _ref = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "If the paddler does not respond, you must manually disable online payment for the paddler, before offering their place to another.");
class OfferPlaceModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      daysAllowed: 5
    });
    _defineProperty(this, "_onConfirmOfferPlace", () => {
      this.props.onEnablePaymentFromWaiting(this.props.entry.id, this.state.daysAllowed);
      this.props.onToggleOfferPlace();
    });
    _defineProperty(this, "_setDaysAllowed", value => {
      this.setState({
        daysAllowed: value
      });
    });
  }
  render() {
    const entry = this.props.entry;
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.props.onToggleOfferPlace
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onConfirmOfferPlace,
      type: "primary"
    }, "Send Email"));
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Offer place and request payment for entry",
      buttons: modalButtons,
      onClose: this.props.onToggleOfferPlace
    }, !entry.matchedPercentileEntries.length ? null : /*#__PURE__*/_react.default.createElement(_alert.default, null, "By slalom rules if you offer ", entry.bibName, " a place you must also offer a place to the following as they are on the same pecentile", entry.matchedPercentileEntries.map(e => /*#__PURE__*/_react.default.createElement("li", {
      key: e.id
    }, e.race.raceName + ' Bib ' + e.startListBib + ' ' + e.bibName))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/_react.default.createElement("p", null, "This will enable this paddler to continue their online booking, by paying for their entry. An email will be sent to ", entry.contactEmail, " requesting them to pay within:"), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-6 col-xs-8 offset-sm-3 offset-xs-2"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Integer",
      name: "daysAllowed",
      value: this.state.daysAllowed,
      onChange: this._setDaysAllowed,
      required: true,
      suffix: " days"
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12"
    }, _ref, /*#__PURE__*/_react.default.createElement(_offerHistory.default, {
      entry: entry
    }))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref2 = _mergeBqlQueries({
  id: true,
  contactEmail: true,
  bibName: true,
  matchedPercentileEntries: {
    id: true,
    bibName: true,
    startListBib: true,
    race: {
      raceName: true
    }
  }
}, _offerHistory.default.partialQueries.Entry);
var _default = exports.default = (0, _reactBicycle.connect)(OfferPlaceModal, props => ({
  ["entry(entryID:" + JSON.stringify(props.entryID) + ")"]: _ref2
}), (client, props) => ({
  onEnablePaymentFromWaiting(entryID, daysAllowed) {
    return client.update('Entry.enablePaymentFromWaiting', {
      entryID,
      daysAllowed
    });
  }
}));